import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { setupErrorHandling } from './utils/errorHandler'

// Setup global error handling
setupErrorHandling()

// Create the app instance
const app = createApp(App)

// Configure the app
app.config.compilerOptions.isCustomElement = (tag) => {
  return tag.startsWith('vue-')
}

// Use plugins
app.use(router)
app.use(store)

// Mount the app
app.mount('#app')